import React from 'react';
import { View, TouchableOpacity, Image } from 'react-native';

import styleHelper from '../Styles/StyleHelper';

import Config from '../Utils/Config';

const IconPlus = (props) => {
    if (props.disabled === true) {
        return (
            <View style={{ opacity: 0.5 }}>
                <ImageIconPlus />
            </View>
        )
    }

    return (
        <TouchableOpacity
            onPress={props.onPress}
            activeOpacity={Config.activeOpacity}>
            <ImageIconPlus />
        </TouchableOpacity>
    )

}

const ImageIconPlus = () => {
    return (
        <Image
            source={require('../img/ic_add_black.png')}
            style={styleHelper.bitsmallIconSize}
            resizeMode={'contain'} />
    )
}

export default IconPlus;